import { render, staticRenderFns } from "./SSuccess.vue?vue&type=template&id=6054ed34&scoped=true&functional=true&"
import script from "./SSuccess.vue?vue&type=script&lang=ts&"
export * from "./SSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./SSuccess.vue?vue&type=style&index=0&id=6054ed34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6054ed34",
  null
  
)

export default component.exports